interface Props {
  title: string;
}

export function ContactCard({ title }: Props) {
  return (
    <div className="nv-contact-card">
      <div className="nv-contact-name">{title}</div>
    </div>
  );
}
